import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CouponState = {
  pagination: PaginationAPI;
  totalElements?: number;
  dataCoupon: CouponType[];
};

export const couponInitialState: CouponState = {
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
  dataCoupon: [],
};

export const slice = createSlice({
  name: 'coupon',
  initialState: couponInitialState,
  reducers: {
    setListCouponAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: CouponType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataCoupon = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },
  },
});

export const { setListCouponAction } = slice.actions;

export default slice.reducer;
